import { useQuery } from '@tanstack/react-query';

import { usePermissions } from '@nucleus-commerce/admin-kit/permissions';

import { storeQueryOptions } from '@/features/stores';

import type { SeoStoreContext } from '../schemas/seo-preview';

/**
 * The store settings the live SEO preview needs. They come from the store detail, which needs
 * `stores.read`; without it (or while it loads) the preview falls back to the saved entity's
 * `resolvedSeo`.
 */
export function useSeoStoreContext(storeId: string): SeoStoreContext | null {
  const { can } = usePermissions();
  const query = useQuery({
    ...storeQueryOptions(storeId),
    enabled: can('stores.read'),
    throwOnError: false,
    meta: { silentError: true },
  });
  const store = query.data;
  if (!store) return null;
  return {
    name: store.name,
    titleTemplate: store.settings.seo.titleTemplate,
    defaultMetaDescription: store.settings.seo.defaultMetaDescription,
    indexable: store.settings.seo.indexable,
    primaryDomain: store.primaryDomain,
  };
}
